import { gql } from '@apollo/client'

const DELETE_FAMILY_RELATION = gql`
  mutation DELETE_FAMILY_RELATION($patientFamily: ID!) {
    deleteFamilyRelation(patientFamily: $patientFamily) {
      id
    }
  }
`

export default DELETE_FAMILY_RELATION
